import MapFeature from './MapFeature'
import { RouteMarker } from '@bikemap/js/map/markers'
import Route from './Route'

/**
 * Shows a route with discover start marker on the map.
 */
export default class DiscoverRoute extends MapFeature {

    /** @type {Route} */
    _route

    /**
     * @param {import("@bikemap/js/entities").Route} route
     */
    constructor(route) {
        super()

        const startMarker = RouteMarker.fromRoute(route)
        startMarker.addEventListener('mouseleave', this._handleMouseLeave.bind(this))

        this._route = new Route(route.points, { startMarker })
    }

    _onAdd(map) {
        this._route.addTo(map)
    }

    _onRemove() {
        this._route.remove()
    }

    _handleMouseLeave() {
        this._dispatchEvent('mouseleave')
    }

}
